import { Grid, IconButton, Tooltip, Typography } from "@mui/material";
import { Box, Container } from "@mui/system";
import React, { useEffect, useState } from "react";
import PageInfoTitle from "../../components/pageTitle/PageInfoTitle";
import StorageTab from "../components/storage/components/StorageTab";
import StorageLeadList from "../components/storage/components/StorageLeadList";
import StorageLeadCardDetails from "../components/storage/components/StorageLeadCardDetails";
import StorageLeadFormDetails from "../components/storage/components/StorageLeadFormDetails";
import StorageLogList from "../components/storage/components/StorageLogList";
import { useDispatch, useSelector } from "react-redux";
import {
  getSingleStorageAction,
  getStorageLogList,
} from "../../store/reducers/storageSlice";
import ContractList from "../components/storage/components/contracts/ContractList";
import refreshIcon from "../../assets/svg/refresh.svg";
import { setNotificationAction } from "../../store/reducers/mmymSlice";

const ClientAdminStorage = () => {
  const dispatch = useDispatch();
  const [generateId, setGenerateId] = useState<string | null>(null);
  const { storageDetails, isCreateContractResponse } = useSelector(
    (state: any) => state.storage,
  );

  useEffect(() => {
    if (generateId) {
      dispatch(
        getSingleStorageAction({
          storageId: generateId,
        }),
      );
    }
  }, [dispatch, generateId]);

  useEffect(() => {
      return () => {
        dispatch(setNotificationAction({ message: [], severity: "error" }));
      };
    }, []);

  useEffect(() => {
    if (isCreateContractResponse && generateId) {
      dispatch(
        getSingleStorageAction({
          storageId: generateId,
        }),
      );
    }
  }, [dispatch, isCreateContractResponse, generateId]);

  return (
    <Grid
      container
      rowSpacing={1}
      columnSpacing={{ xs: 1, sm: 1, md: 1 }}
      sx={{ background: "#f4f4f4" }}
    >
      {/* ─── LEFT PANEL: Lead List ─── */}
      <Grid item xs={12} md={3}>
        <Box sx={{ height: { xs: "auto", md: "100vh" } }}>
          <StorageLeadList setGenerateId={setGenerateId} />
        </Box>
      </Grid>

      {/* ─── RIGHT PANEL: Details ─── */}
      <Grid item xs={12} md={9}>
        <Container
          maxWidth="lg"
          sx={{
            paddingLeft: "0px !important",
            paddingRight: "0px !important",
          }}
        >
          <Box
            sx={{
              height: { xs: "auto", md: "100vh" },
              paddingLeft: "0px !important",
              paddingRight: "0px !important",
              overflow: "scroll",
            }}
          >
            {/* ─── Sticky Header ─── */}
            <Box
              sx={{
                position: "sticky",
                top: 0,
                bgcolor: "#fff",
                zIndex: 1,
                border: "1px solid #C4CDD5",
              }}
            >
              <PageInfoTitle
                title=""
                desc={
                  storageDetails?.leadId
                    ? `Ref No. ${storageDetails?.leadId}`
                    : ""
                }
                leadId={storageDetails?.leadId}
                isPrint={false}
                isEmail={false}
                isText={false}
                disabled1={!storageDetails?.leadId}
                disabled={true}
              />
              <StorageTab leadDetails={storageDetails} />
            </Box>

            {/* ─── Card Details ─── */}
            <StorageLeadCardDetails leadDetails={storageDetails} />

            {/* ─── Form Details ─── */}
            <Box
              sx={{
                bgcolor: "#fff",
                height: { xs: "auto" },
                border: "1px solid #d1cfcf",
                borderRadius: "5px",
                overflow: "hidden",
                padding: "10px 0px !important",
              }}
            >
              {storageDetails && storageDetails?.leadId ? (
                <StorageLeadFormDetails leadDetails={storageDetails} />
              ) : (
                <center>
                  <Typography sx={{ color: "#4A4A4A" }}>
                    No Record Found!
                  </Typography>
                </center>
              )}
            </Box>

            {/* ─── Manage Lead Section ─── */}
            <Box
              sx={{
                bgcolor: "#fff",
                height: { xs: "auto" },
                border: "1px solid #d1cfcf",
                borderRadius: "5px",
                marginTop: "10px",
                padding: "0px 10px 10px 10px !important",
              }}
            >
              <Typography
                sx={{
                  textTransform: "capitalize !important",
                  padding: "10px 0px",
                  fontWeight: 800,
                  color: "#333333",
                  fontSize: "16px",
                }}
                variant="subtitle1"
              >
                Manage Lead
              </Typography>
              <ContractList generateId={generateId} />
              {/* <StorageManageSection generatedId={generateId} /> */}
            </Box>

            {/* ─── Logs Section ─── */}
            {storageDetails?.leadId && (
              <Box
                sx={{
                  bgcolor: "#fff",
                  height: { xs: "auto" },
                  border: "1px solid #d1cfcf",
                  borderRadius: "5px",
                  marginTop: "10px",
                  padding: "10px !important",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                    justifyContent: "space-between",
                  }}
                >
                  <Typography
                    sx={{
                      textTransform: "capitalize !important",
                      padding: "0px",
                      fontWeight: 800,
                      color: "#333333",
                      fontSize: "16px",
                    }}
                    variant="subtitle1"
                  >
                    Logs
                  </Typography>
                  <Tooltip title="Refresh logs" placement="left">
                    <IconButton
                      size="small"
                      aria-label="Refresh logs"
                      onClick={() => {
                        // Call the log list API directly
                        if (storageDetails?.leadId) {
                          dispatch(
                            getStorageLogList({
                              page: 1,
                              limit: 10,
                              orderBy: "created_at",
                              orderIn: "DESC",
                              leadId: storageDetails?.leadId,
                              contractId: "",
                            }),
                          );
                        }
                      }}
                      sx={{ ml: 1 }}
                    >
                      <img
                        src={refreshIcon}
                        alt="refresh"
                        style={{ width: 20, height: 20 }}
                      />
                    </IconButton>
                  </Tooltip>
                </Box>
                <StorageLogList leadId={generateId} />
              </Box>
            )}
          </Box>
        </Container>
      </Grid>
    </Grid>
  );
};

export default ClientAdminStorage;
